import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SubscriptionCancelReason } from '../enums';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionCancelReasonProviderService {
  private readonly entries = new Map<SubscriptionCancelReason, string>([
    [SubscriptionCancelReason.ByAdmin, 'Decyzja Administratora'],
    [SubscriptionCancelReason.ByOwner, 'Decyzja użytkownika'],
    [SubscriptionCancelReason.ByExpiredCard, 'Wygaśnięcie karty płatniczej'],
  ]);

  public labelFor(reason: SubscriptionCancelReason): Observable<string> {
    const result = this.entries.get(reason);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${reason}" is not found.`,
      );
    }

    return of(result);
  }
}
